import axios from '@/plugins/axios'

const getTimezones = () => axios.get('timezones')
const getCountries = () => axios.get('countries')

export {
    getTimezones,
    getCountries,
}
